import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'abw-command-gridinput-emplacements-dialog',
    templateUrl: './command-gridinput-emplacements-dialog.component.html',
    styleUrls: ['./command-gridinput-emplacements-dialog.component.scss']
})
export class CommandGridInputEmplacementsDialog implements OnInit {
    mDocLigne: any;

    constructor(
        public dialogRef: MatDialogRef<CommandGridInputEmplacementsDialog>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.mDocLigne = data.ligne;
    }

    ngOnInit() {
    }
    
    dismiss() {
        this.dialogRef.close(false);
    }
}